import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import { createClient } from "@supabase/supabase-js";

import { Page } from "../views/Page";
import { ROUTES } from "./routes";
import ScrollToTop from "../components/ScrollToTop";
import { OrganizerPage } from "../views/Organization";
import { OnboardingOrgPage } from "../views/OnboardingOrgPage";
import { EventsPage } from "../views/EventsPage";
import { EventStatistics } from "../views/EventStatistics";
import { CustomerProfile } from "../views/CustomerProfile/CustomerProfile";
import { ManageEvent } from "../views/EventManagement";
import { CreateEvent } from "../views/CreateEvent";
import { Overview } from "../views/Overview";
import { Onboarding } from "../views/Overview/Onboarding";
import { SnackbarComponent } from "../components/SnackbarComponent";
import Logs from "../views/Logs";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);

const Routing = () => {
  let { userData } = useSelector((state) => state.main);
  let { session } = useSelector((state) => state.main);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbar = (message, severity) => {
    setSnackbar({
      open: true,
      message: message,
      severity: severity,
    });
  };

  return (
    <BrowserRouter>
      <Page
        supabase={supabase}
        handleSnackbar={handleSnackbar}
        userData={userData}
        session={session}
      >
        <ScrollToTop />
        <SnackbarComponent snackbar={snackbar} setSnackbar={setSnackbar} />
        <Routes>
          <Route
            path={ROUTES.DEFAULT}
            element={
              <Overview
                userData={userData}
                supabase={supabase}
                handleSnackbar={handleSnackbar}
              />
            }
          />
          <Route
            path={ROUTES.NEW_PASSWORD}
            element={
              <Overview
                userData={userData}
                supabase={supabase}
                handleSnackbar={handleSnackbar}
              />
            }
          />
          <Route
            path={ROUTES.ONBOARDING}
            element={<Onboarding userData={userData} />}
          />
          <Route
            path={ROUTES.EVENTS}
            element={<EventsPage userData={userData} />}
          />
          <Route
            path={ROUTES.CREATE_EVENT}
            element={
              <CreateEvent
                handleSnackbar={handleSnackbar}
                supabase={supabase}
                userData={userData}
              />
            }
          />
          <Route
            path={ROUTES.ORGANIZATION}
            element={
              <OrganizerPage
                userData={userData}
                supabase={supabase}
                handleSnackbar={handleSnackbar}
              />
            }
          />
          <Route
            path={ROUTES.LOGS}
            element={
              <Logs userData={userData} handleSnackbar={handleSnackbar} />
            }
          />
          <Route path={ROUTES.CUSTOMER_PROFILE} element={<CustomerProfile />} />
          <Route
            path={ROUTES.EVENT}
            element={
              <EventStatistics
                userData={userData}
                handleSnackbar={handleSnackbar}
              />
            }
          />
          <Route path={ROUTES.CUSTOMIZE_EVENT} element={<EventStatistics />} />
          <Route
            path={ROUTES.MANAGE_EVENT}
            element={
              <ManageEvent
                userData={userData}
                handleSnackbar={handleSnackbar}
                supabase={supabase}
              />
            }
          />
          <Route
            path={ROUTES.ONBOARDING_ORGANIZER}
            element={<OnboardingOrgPage />}
          />
        </Routes>
      </Page>
    </BrowserRouter>
  );
};

export default Routing;
